import { render } from "./ClusterAdd.vue?vue&type=template&id=5c8e1ff2&scoped=true"
import script from "./ClusterAdd.vue?vue&type=script&lang=js"
export * from "./ClusterAdd.vue?vue&type=script&lang=js"

import "./ClusterAdd.vue?vue&type=style&index=0&id=5c8e1ff2&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8e1ff2"]])

export default __exports__